import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type ContentFunnel } from '../../entity/api/content-funnel';
import { createBasicStoreState } from './basic-store';

type TModel = ContentFunnel;

type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'articles-funnels' }
  )
);
